/**
 *
 */
(function () {
  'use strict';
  angular.module('cbl.finanza.mf.directives', ['cbl.common']);
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/fin.directives.js
 ** module id = 3
 ** module chunks = 0 1 2
 **/